export default __webpack_public_path__ + "static/media/Monie_Tree.124eabc6.png";